const Nbsp = () => "\u00A0";
export default Nbsp;
